whenAvailable('$', function() {
$(function(){
    whenAvailable('slick',function() {
        $('#galleryCarousel')?.slick({
            slidesToShow: 1,
            infinite: false,
            arrows: false,
            asNavFor: '#thumbnailCarousel',
        }).on('beforeChange', function(event, slick, currentSlide, nextSlide){
            if (currentSlide != nextSlide) {
                $('#thumbnailCarousel .gallery-slide').addClass('disabled');
            }
        }).on('afterChange', function(){
            $('#thumbnailCarousel .gallery-slide').removeClass('disabled');
        });

        $('#thumbnailCarousel')?.slick({
            infinite: false,
            slidesToShow: 3,
            arrows: false,
            focusOnSelect: true,
            //centerMode: true,
            asNavFor: '#galleryCarousel',
        });
    });

    // KR checkbox
    if ($('.terms-kr').length > 0) {
        let checkboxTarget = '.terms-kr .field.stack';
        $(checkboxTarget).change(function() {
            if ($(this).hasClass('all')) {
                if ($(checkboxTarget + '.all .input-checkbox')[0].checked) { $(checkboxTarget + '.single .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.single .input-checkbox').prop('checked', false); }
            } else {
                var allChecked = true;
                $(checkboxTarget + '.single .input-checkbox').each(function(i,v) { if (!this.checked) { allChecked = false; } });
                if (allChecked == true) { $(checkboxTarget + '.all .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.all .input-checkbox').prop('checked', false); }
            }
        });
    }

    // Redemption Form
    const $form = $('#redeemForm'),
          $formFields = $('#redeemForm input:not([type=hidden]), #redeemForm select'),
          $formSubmit = $('#submitForm');

    $('#redeem_btn').click(function(){
        $('.redemption-step1').hide();
        $('.redemption-step2').fadeIn();
    });

    $formFields.on('change', function(){
        if (this.id == 'store_code') {
            if (this.value.length > 0) {
                var order_no;
                if ( this.value == 'SG' ) {
                    order_no = '0020000S';
                } else if ( this.value == 'MY' ) {
                    order_no = 'A004000A';
                } else if ( this.value == 'KR' ) {
                    order_no = '360000KR';
                } else if ( this.value == 'AU' ) {
                    order_no = '#2000000';
                } else if ( this.value == 'NZ' ) {
                    order_no = '200000NZ';
                } else if ( this.value == 'UK' ) {
                    order_no = '4000000UK';
                } else if ( this.value == 'EU' ) {
                    order_no = '#300000EU';
                } else if ( this.value == 'US' ) {
                    order_no = '03000000US';
                } else if ( this.value == 'CA' ) {
                    order_no = '#5000000CA';
                }
                $('#redeemForm #shopify_order_name').prop('disabled', false).removeClass('bg-secondary').attr('placeholder', order_no);
            }
        } else if (this.id == 'shopify_order_name') {
            _this = $(this);
            $.post('https://beans.secretlab.co/index.php/api/2019-08/'+shop_locale+'/verify_order_no/', {
                order_no:     _this.val(),
                country_code: $('#redeemForm #store_code').val(),
                link_shopify: 'Y',
                store_type:   'secretlab'
            }, function (data) {
                if ('ok' === data.status) {
                    _this.removeClass('is-invalid');
                    _this.get(0).setCustomValidity('');
                } else {
                    _this.addClass('is-invalid').focus();
                    _this.get(0).setCustomValidity('Please provide a valid order number.');
                }
            }, 'json');
        }
    })

    $formSubmit.on('click', function(){
        $.validateForm('#redeemForm');
    });

    $form.submit(function (e) {
        e.preventDefault();

        const formData = new FormData(this);
        $.submitForm('https://beans.secretlab.co/index.php/api/api_campaign_participate', formData, $form);
    });
});
});
